import {createStyles, Theme} from "@material-ui/core/styles";
import {styleColors} from "src/main.style";

export const TodoStyle = (theme: Theme) => createStyles({
  "@global": {
    ".slide-out-elliptic-right-bck": {
      WebkitAnimation: "slide-out-elliptic-right-bck 1s linear both",
      animation: "slide-out-elliptic-right-bck 1s linear both",
      maxHeight: "0px !important",
      minHeight: "0px !important",
    },
    "@keyframes slide-out-elliptic-right-bck": {
      "0%": {
        opacity: 1,
        WebkitTransformOrigin: "50% 50%",
        transformOrigin: "50% 50%",
        WebkitTransform: "scale(1, 1) rotateY(0deg)",
        transform: "scale(1, 1) rotateY(0deg)",
      },
      "80%": {
        opacity: 0,
        WebkitTransformOrigin: "50% 50%",
        transformOrigin: "50% 50%",
        WebkitTransform: "scale(0, 0) rotateY(180deg)",
        transform: "scale(0, 0) rotateY(180deg)",
        maxHeight: "200px",
        margin: "initial",
        padding: "initial",
      },
      "100%": {
        opacity: 0,
        maxHeight: "0px",
        margin: "0px",
        padding: "0px",
      },
    },
  },
  toDoItem: {
    flexGrow: 1,
    display: 'flex',
    padding: theme.spacing(2.5),
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxShadow: theme.shadows[4],
    borderRadius: '14px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    width: '100%',
    minWidth: '320px',
    maxWidth: '420px',
    position: 'relative',
    border: `1px solid ${styleColors.blackAlpha23}`,
    transition: 'all 2s',
    transitionDelay: '1s',
    zIndex: 1,
    maxHeight: '500px',
    userSelect: 'none',
  },
  embedded: {
    gap: '2px',
    margin: '3px 4px',
    padding: '3px',
    flexGrow: 1,
    maxWidth: 'calc(100% - 8px)',
    borderRadius: '5px',
    boxShadow: 'none',
  },
  handoverList : {
    minWidth: 'unset',
    borderRadius: '0px',
    border: `0px solid ${styleColors.blackAlpha23}`,
  },
  cardTop: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginTop: '-8px',
    marginBottom: '-8px',
  },
  roundCheckbox: {
    width: '25px',
    height: '25px',
    borderRadius: '25px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    backgroundColor: styleColors.greyMedium1,
    position: 'relative',
    zIndex:2,
    margin: '8px 0px 8px 12px',
    WebkitUserSelect: 'none',
  },
  roundCheckboxChecked: {
    backgroundColor: theme.palette.secondary.main,
  },
  roundCheckboxCompact: {
    width: '20px',
    height: '20px',
    borderRadius: '20px',
    marginRight: '2px',
  },
  roundCheckboxInput: {
    position: 'absolute',
    appearance: 'none',
    zIndex: -1,
  },
  completedText: {
    color: styleColors.greyMedium1,
  },
  cardMiddle: {},
  todoDesc: {
    whiteSpace: 'pre-wrap',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  seenBy: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    fontSize: '0.666666rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    color: styleColors.greyMedium2,
  },
  avatars: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'flex-Start',
  },
  todoUnseen: {
    boxShadow: `0px 3px 30px ${styleColors.redShadow23}`,
  },
  archiveButton: {
    padding: '10px',
    margin: '-10px',
    fontSize: '0.625rem',
    textTransform: 'uppercase',
    fontWeight: 600,
    zIndex:2,
  }
});



// WEBPACK FOOTER //
// ./src/components/todo/todo.style.ts